import { BusinessObjectBase, ModelBase, QueryBus } from '@skylab-shared/core';
import { InventoryDocumentKind, PurchaseDocumentKind } from '@skylab-shared/dataModel';
import { last } from '@skylab-shared/utils';
import { ContextKeys } from '../../../../../business/src/lib/common/context-keys';
import { DocumentLink, DocumentLinks, DocumentLinksQuery } from '../../../../../business/src/lib/documents/queries/document-links.query-base';

interface ModelPart extends ModelBase {
    id: number;
    kind: PurchaseDocumentKind;
}

export class PurchaseLinksMixin<TModel extends ModelPart> extends BusinessObjectBase<TModel>  {
    protected queryBus: QueryBus;

    public async loadLinksAsync(): Promise<void> {
        this.internalLinks = await this.localContext.getAsync(ContextKeys.documentLinks(this.model.id), () => this.queryBus.queryAsync(new DocumentLinksQuery(this.model.id)));
        this.internalInventory = this.internalLinks.inventory;
        this.internalCurrent = this.internalLinks.current;
    }

    private internalLinks: DocumentLinks;
    public get links(): DocumentLinks {
        return this.internalLinks;
    }

    public get linksAdjustments(): DocumentLink[] | undefined | null {
        return this.links?.adjustments;
    }

    private internalCurrent: DocumentLink;
    public get linksCurrent(): DocumentLink {
        return this.internalCurrent;
    }

    private internalInventory: DocumentLink[] | undefined | null;
    public get linksInventory(): DocumentLink[] | undefined | null {
        return this.internalInventory;
    }

    public get linksInvoiceIssuedToInventoryGoodsReceipt(): boolean {
        return !!this.linksInventory?.some(elem => elem.kind === InventoryDocumentKind.GoodsReceipt);
    }

    public get linkPreviouslyAdjusted(): DocumentLink | undefined {
        return this.linksAdjustments?.find((_, index) => this.linksAdjustments?.[index + 1]?.documentId === this.model.id);
    }

    public get isDocumentAdjusted(): boolean {
        if (!this.linksAdjustments) return false;
        return last(this.linksAdjustments).documentId !== this.model.id;
    }
}
